import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import Editor from './editor';
import DocumentList from './document_list';
import {
    loadNewDocument, setNextInputType, addInput, deleteInput, updateInput, moveInput,
    getAllStaticDocuments, saveCurrentDocument, getUserDocuments, loadExistingDocument,
    finalizeDocument, finishedFinalizingDocument
} from './editor_actions';
import { createPdf } from '../../common/common_actions';

class DocumentEditor extends Component {
    componentDidMount() {
        const { name } = this.props;
        this.props.loadNewDocument(name);

        if (this.props.staticDocuments.length === 0) {
            this.props.getAllStaticDocuments();
        }

        this.props.getUserDocuments();
    }

    render() {
        return (
            <Row>
                <Col md={12}>
                    {
                        (this.props.isDocumentImageLoaded) ?
                            <Editor
                                formData={this.props.formData}
                                imageUrl={this.props.imageUrl}
                                setNextInputType={this.props.setNextInputType}
                                addInput={this.props.addInput}
                                updateInput={this.props.updateInput}
                                moveInput={this.props.moveInput}
                                deleteInput={this.props.deleteInput}
                                finishDocument={this.props.finalizeDocument}
                                finishedFinalizingDocument={this.props.finishedFinalizingDocument}
                                saveCurrentDocument={this.props.saveCurrentDocument}
                                isDocumentFinished={this.props.isDocumentFinished}
                                staticDocuments={this.props.staticDocuments}
                                userDocuments={this.props.userDocuments}
                                onLoadNewDocument={this.props.loadNewDocument}
                                onLoadExistingDocument={this.props.loadExistingDocument}
                                createPdf={this.props.createPdf}
                            /> :
                            <div>Loading</div>
                    }
                </Col>
            </Row>


        );
    }
}

const mapStateToProps = (state) => {
    // TODO: The name should be passed in some other way
    return {
        ...state.editor,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllStaticDocuments: () => dispatch(getAllStaticDocuments()),
        getUserDocuments: () => dispatch(getUserDocuments()),
        loadNewDocument: name => dispatch(loadNewDocument(name)),
        loadExistingDocument: name => dispatch(loadExistingDocument(name)),
        setNextInputType: docType => dispatch(setNextInputType(docType)),
        addInput: (top, left) => dispatch(addInput(top, left)),
        deleteInput: (id) => dispatch(deleteInput(id)),
        saveCurrentDocument: (name) => dispatch(saveCurrentDocument(name)),
        updateInput: (id, value) => dispatch(updateInput(id, value)),
        moveInput: (id, top, left) => dispatch(moveInput(id, top, left)),
        finalizeDocument: () => dispatch(finalizeDocument()),
        finishedFinalizingDocument: () => dispatch(finishedFinalizingDocument()),
        createPdf: (html, name) => dispatch(createPdf(html, name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentEditor);



// WEBPACK FOOTER //
// ./src/components/document-editor/index.jsx